

$('.swatch-element label').hover(function () {
        $(this).prev().prev().addClass('active');
        
    }, function () {
        $(this).prev().prev().removeClass('active');
    }
);

$('.swatch-element label').click(function (e) { 
    e.preventDefault();
    
    $('.swatch-element label').removeClass('selected')
    $(this).toggleClass('selected');

    $(this).prev().prop("checked", true).trigger('change');

    $('.product-form__input input').each(function (index, element) {
        // element == this

        if ($(element).prop("checked") == true) {
            $(element).prop("checked", false).trigger('change');

            $('.product-form__submit').addClass('disabled');
        }
    });

});

$('.swatch-1').remove();

var numItems = $('.swatch-element').length;

if (numItems == 1) {
    $('.swatch-element input').prop("checked", true).trigger('change');
    $('.swatch-element').css('display', 'none');
}

if ($('.swatch-element label').length == 0) {
    $('.product-form__submit').removeClass('disabled');
}

$(document).ready(function () {
    
    // This is a mess, but I need to wait for the plugin to load a custom swatch

    // Select the node that will be observed for mutations
    const targetNode = document.getElementById("infiniteoptions-container");

    console.log(targetNode);

    // Options for the observer (which mutations to observe)
    const config = { attributes: true, childList: true, subtree: true };

    // Callback function to execute when mutations are observed
    const callback = (mutationList, observer) => {
        for (const mutation of mutationList) {
            if (mutation.type === "childList") {
                // console.log("A child node has been added or removed.");
                observer.disconnect();

                editSwatch();

                $('.spb-productoptionswatchwrapper').hover(function () {
                    $(this).find('.tooltip').addClass('active');
                    
                    }, function () {
                        $(this).find('.tooltip').removeClass('active');
                    }
                );

            } else if (mutation.type === "attributes") {
                // console.log(`The ${mutation.attributeName} attribute was modified.`);
            }
        }
    };

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);

    // Start observing the target node for configured mutations
    observer.observe(targetNode, config);

    function editSwatch() {
        let colorName = "";

        $('.spb-productoptionswatchwrapper').each(function (index, element) {
            colorName = $(element)[0].textContent;
            $(element)[0].childNodes[2].remove();   
            
            $(element).append(`<div class="tooltip">${colorName}</div>`);
        });

        $('.swatch-0').css("display", "none");

        $('.product-form__submit').addClass('disabled');
        
        $('.product-form__input input').click(function (e) { 

            var selectedSize = $(this).val();

            var inputElement = $('.swatch-0 input:radio').filter(function() {
                return $(this).val() === selectedSize;
            });

            inputElement.prop("checked", true).trigger('change');
        });
    }
});